module.exports = __webpack_public_path__ + "static/media/certificat.4d51580d.webp";